const generateRandomId = () => {
    return (
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(10, 15)
    );
};

export { generateRandomId };
